import React, { useState } from 'react';
import Header from '../../../../../Header/Header';
import Navigationbar from '../../../../../Navigationbar/Navigationbar';
import CSCELogs from './CSCELogs';
import CustomButtonSS from '../../../../../Common/CustomButton/CustomButtonSS';

/**
 * Used to show the action item on the nav bar and when user clicks on 
 * that it will take the user to the particular component
 * @param {*} props 
 * @returns 
 */
const CSCELogsWrapper = (props) => {

    const { themeSelected } = props;
    const [view, setView] = useState('T');

    return (
        <div className='container-fluid m-1'>
            <Header {...props} />
            <Navigationbar {...props} />
            <>
            <div className='m-2 d-flex justify-content-between'>
              <div>
                <CustomButtonSS
                            disabled={view === 'T' ? true: false}
                            isLoading={false}
                            title={'Tabular'}
                            className={`addButton mx-1 ${view === 'T' ? '': 'disabledActionColor'}`}
                    onClick={() => {
                        // dispatch({ type: sagaActions.RESET_USER_RATINGS_ACTION });
                        setView('T')
                            }}>Tabular</CustomButtonSS>
                <CustomButtonSS
                             disabled={view === 'G' ? true: false}
                            isLoading={false}
                            title={'Graphical'}
                            className={`addButton mx-1 ${view === 'G' ? '': 'disabledActionColor'}`}
                    onClick={() => {
                        // dispatch({ type: sagaActions.RESET_USER_RATINGS_ACTION });
                        setView('G')
                    }}
                >Graphical</CustomButtonSS>
                </div>
            </div>
                <CSCELogs className='mt-3' themeSelected={themeSelected} view={ view } />
            </>
        </div>
    )
}

export default CSCELogsWrapper;